module.exports = __webpack_public_path__ + "static/media/results-project-new-1@2x.470b08f8.jpg";